import React, { Component } from 'react';
import { DESC } from '../../../BaseDataTable';
import { Tooltip } from '@material-ui/core';
import { ArrowUpward, ArrowDownward, Info as InfoIcon } from '@material-ui/icons';
import { arrayOf, shape, string, any, func} from 'prop-types';
import classNames from 'classnames';
import styles from './styles.scss';
import { ADS_ICON_TOOLTIP_TEXT } from '../constants';

export default class TableHead extends Component {
  static propTypes = {
    headers: arrayOf(shape({
      title: string,
      key: string
    })).isRequired,
    tooltipText: string,
    sortKey: string,
    sortStatus: shape({any}),
    onCellClick: func,
    iconKey: string
  }

  static defaultProps = {
    tooltipText: 'Sort',
    iconKey: 'ads'
  }

  drawArrowIcon() {
    const { sortKey, sortStatus } = this.props;
    const arrowIcon = sortStatus[sortKey] === '' || 
                      sortStatus[sortKey] === DESC? 
                      <ArrowDownward className={styles.arrowIcon}/> :
                      <ArrowUpward className={styles.arrowIcon}/>;
    return <span>{arrowIcon}</span>
  }

  drawTableHead() {
    const { headers, sortKey, onCellClick, tooltipText, iconKey } = this.props;
    return headers && headers.map( header => {
      const { title, key } = header;
      const arrowIcon = sortKey === key && this.drawArrowIcon();
      if (title && key) {
        return (
          <div className={classNames(styles.tableCell, styles.tableHeadCell)} onClick={onCellClick(key)} key={key}>
              {arrowIcon}
              <Tooltip title={tooltipText} placement="top-start">
                <span>{header.title}</span>
              </Tooltip>
            {key === iconKey &&
            <Tooltip title={ADS_ICON_TOOLTIP_TEXT} placement="top-start">
              <InfoIcon className={styles.adsIcon}/>
            </Tooltip>}
          </div>
        )
      }
    })
  }
  render() {
    const tableCell = this.drawTableHead();
    return(
      <div className={styles.tableRow}>
        {tableCell}
      </div>
    )
  }
}
